import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { ServerMeta } from 'types/common';

interface ContentItemProps {
    condition?: ServerMeta;
    status: string;
    onEdit: () => void;
}

const TableContentItem: React.FC<ContentItemProps> = ({
    condition,
    status,
    onEdit,
}) => {
    return (
        <div className={s.contentItem}>
            <div className={s.header}>
                <h3 className={s.title}>{condition?.content}</h3>
                <Button
                    onClick={onEdit}
                >
                    Edit
                </Button>
            </div>

            <div className={s.content}>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Status</div>
                    <div className={s.dataValue}>{status === 'A' ? 'Active' : 'Inactive'}</div>
                </div>
            </div>
        </div>
    );
};

export default TableContentItem;
